export class InvoiceSettings {
  id: string;
  merchantId: string;
  reminderFrequency: string;
  reminderFrequencyCustomDays: number;
  customerReceiptEmail: boolean;
  merchantReceiptEmail: boolean;
  generateInvoiceNumber: boolean;
  nextNumber: number;
  initialNotification: string;
  subsequentNotification: string;
  lateReminderNotification: string;

  constructor(m: Partial<InvoiceSettings>) {
    this.id = m.id || '';
    this.merchantId = m.merchantId || '';
    this.reminderFrequency = m.reminderFrequency || '';
    this.reminderFrequencyCustomDays = m.reminderFrequencyCustomDays || 0;
    this.customerReceiptEmail = m.customerReceiptEmail || false;
    this.merchantReceiptEmail = m.merchantReceiptEmail || false;
    this.generateInvoiceNumber = m.generateInvoiceNumber || true;
    this.nextNumber = m.nextNumber || 0;
    this.initialNotification = m.initialNotification || '';
    this.subsequentNotification = m.subsequentNotification || '';
    this.lateReminderNotification = m.lateReminderNotification || '';
  }

  static createEmpty(): InvoiceSettings {
    return new InvoiceSettings({
      id: '',
      merchantId: '',
      reminderFrequency: '',
      reminderFrequencyCustomDays: 0,
      customerReceiptEmail: false,
      merchantReceiptEmail: false,
      generateInvoiceNumber: true,
      nextNumber: 0,
      initialNotification: '',
      subsequentNotification: '',
      lateReminderNotification: '',
    });
  }
}
